<div class="error-container" *ngIf="errorMessage!=''">

  <div class="row">
    <div class="col-sm-12 invalid text-center"> {{errorMessage}} </div>
  </div>
  <div class="row" *ngIf="navigateLink">
    <div class="col-sm-12">
      <a class="btn btn-default" [href]="navigateLink">Back To Login</a>
      <a class="btn btn-default" style="margin-left: 25px;" [href]="lobbyLink">Back To Lobby</a>
    </div>
  </div>
</div>
